import router from "@/router";
import * as MUTATIONS from "@/config/constants/mutation-types";
import config from "@/config/brands/index";
import {
  caminosBiometria,
  setearCaminosBiometria
} from "@/config/constants/caminosBiometria";

jest.mock("@/router", () => ({
  replace: jest.fn()
}));

describe("caminosBiometria", () => {
  let commit;

  beforeEach(() => {
    commit = jest.fn();
    jest.clearAllMocks();
  });

  it("caminosBiometria constantes caminos", () => {
    expect(caminosBiometria).toBeDefined();
    expect(caminosBiometria).not.toBeNull();
    expect(typeof caminosBiometria).toBe("object");
  });

  it("caminosBiometria constantes ERROR", () => {
    const getResult = {
      data: {}
    };
    const cb = jest.fn();
    caminosBiometria.ERROR({ commit }, getResult, cb);
    expect(cb).toHaveBeenCalled();
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_ERROR_VERIDAS,
      "error-reintentos-biometria"
    );
  });

  it("caminosBiometria constantes errorCA", () => {
    const cb = jest.fn();
    caminosBiometria.errorCA({ commit }, cb);
    expect(cb).toHaveBeenCalled();
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_ERROR_VERIDAS,
      "error-veridas-ca"
    );
  });

  it("caminosBiometria constantes biometriaOk", () => {
    const cb = jest.fn();
    config.pasos = {
      ...config.pasos,
      loadingVeridas: {
        pasoSiguiente: "biometriaOK"
      },
      biometriaOK: {
        path: "/biometria-ok"
      }
    };
    caminosBiometria.biometriaOk({ commit }, cb);
    expect(cb).toHaveBeenCalled();
    expect(router.replace).toHaveBeenCalled();
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_BIOMETRIA_POSITIVO, {
      isValid: true
    });
  });

  it("caminosBiometria constantes pperless", () => {
    const cb = jest.fn();
    caminosBiometria.pperless({ commit }, cb);
    expect(cb).toHaveBeenCalled();
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_ERROR_VERIDAS,
      "error-reintentos-biometria"
    );
  });

  it("caminosBiometria constantes reintentoOk", () => {
    const cb = jest.fn();
    caminosBiometria.reintentoOk({ commit }, cb);
    expect(cb).toHaveBeenCalled();
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_ERROR_VERIDAS,
      "no-identificado-veridas"
    );
  });

  it("caminosBiometria constantes setearCaminosBiometria return errorCA when circuito CGU", () => {
    const isValid = false;
    const puedeReintentar = false;
    const response = setearCaminosBiometria(isValid, puedeReintentar, "CGU");
    expect(response).toBe("errorCA");
  });

  it("caminosBiometria constantes setearCaminosBiometria return biometriaOk", () => {
    const isValid = true;
    const puedeReintentar = false;
    const response = setearCaminosBiometria(isValid, puedeReintentar);
    expect(response).toBe("biometriaOk");
  });

  it("caminosBiometria constantes setearCaminosBiometria return reintentoOk", () => {
    const isValid = false;
    const puedeReintentar = true;
    const response = setearCaminosBiometria(isValid, puedeReintentar);
    expect(response).toBe("reintentoOk");
  });

  it("caminosBiometria constantes setearCaminosBiometria return pperless", () => {
    const isValid = false;
    const puedeReintentar = false;
    const response = setearCaminosBiometria(isValid, puedeReintentar);
    expect(response).toBe("pperless");
  });
});
